import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Notification } from '../../../common/notification'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { changeAllowSetDefaultUnit } from '../../../common/selectCurrencyUnit/slice'
import { COMPANY_TYPES } from '../../../utils/common'
import { Layout } from '../../Layout'
import { CompanyInfo } from '../../common/header/companyInfo'
import useCheckIsCompanyType from '../../common/header/companyInfo/useCheckIsCompanyType'
import { Content } from './Content'
import { FiscalYear } from './FiscalYear'
import { Sticky } from './Sticky'
import { selectIsFirstLoad } from './highlight/store/slice'
import { selectIsFirstLoadScale } from './industryScale/store/slice'
import './lang/i18n'
import { selectIsFirstLoadTableData } from './topIndustryPlayers/store/slice'

export const IndustryOverview = () => {
  const dispatch = useDispatch()

  const isFirstLoadHightLight = useSelector(selectIsFirstLoad)
  const isFirstLoadTopPlayer = useSelector(selectIsFirstLoadTableData)
  const isFirstLoadScale = useSelector(selectIsFirstLoadScale)
  const isFirstLoad =
    isFirstLoadHightLight && isFirstLoadTopPlayer && isFirstLoadScale

  useEffect(() => {
    if (isFirstLoad) {
      dispatch(
        changeAllowSetDefaultUnit({
          screen: SCREEN.INDUSTRY_OVERVIEW,
          value: false,
        }),
      )
    }
  }, [isFirstLoad])

  const isUnavailable = useCheckIsCompanyType([
    COMPANY_TYPES.FUNDS,
    COMPANY_TYPES.INSURANCE,
  ])

  const renderBottomComponent = () => {
    if (isUnavailable) {
      return (
        <Notification
          isI18n
          value="errorCommon.COMPANY_TYPE_ERROR"
          style={{ fontSize: 20 }}
        />
      )
    }

    return (
      <FiscalYear>
        <Content />
      </FiscalYear>
    )
  }

  return (
    <Layout
      renderTopComponent={() => <CompanyInfo />}
      renderStickyComponent={() =>
        !isUnavailable && (
          <FiscalYear isFetchAPI={false} isShowLoading={false}>
            <Sticky />
          </FiscalYear>
        )
      }
      renderBottomComponent={renderBottomComponent}
      isLoadingContent={!isUnavailable && !isFirstLoad}
      isShowFooter={false}
    />
  )
}

export default IndustryOverview
